import { ref } from "vue"
import { Core, Identification, BirthRecords, SocialSecurity, ProfileTypes, Citizen } from "@minicity/core"
import { FormNavState, Section, useForm } from "@/composables/useForm";
import { sessionState } from "@/core/session";
import { generateRandomId } from "@/core/utils";
import { RegisterRequest, register } from "./api";
import { CitizenInvite } from "./model";

// Define all pages in the form
export type Page = 
    "welcome"
    | "termsAndWaivers"
    | "selectSiteAndCaseworker" | "ambassadorSelfieCapture"
    | "usernameAndPassword"
    | "basicCitizenInfo"
    | "contactInfo"
    | "demographicCategories" | "needsCategories"
    | "classifierQuestions" | "hmisClassifierQuestions"
    | "equifaxConsent"
    | "signature"
    | "preSubmit" | "completed";

// Group pages into sections
export const sections:Section<Page>[] = [
    {name: "Welcome to Mini City", pages: [
        "welcome"
    ]},
    {name: "Terms And Conditions", pages: [
        "termsAndWaivers"
    ]},
    {name: "Your Caseworker", pages: [
        "selectSiteAndCaseworker", "ambassadorSelfieCapture"
    ]},
    {name: "Verification Selfie", pages: [
        "ambassadorSelfieCapture"
    ]},
    {name: "Username And Password", pages: [
        "usernameAndPassword"
    ]},
    {name: "About You", pages: [
        "basicCitizenInfo", "contactInfo"
    ]},
    {name: "How Can We Help?", pages: [
        "demographicCategories", "needsCategories"
    ]},
    {name: "Final Questions", pages: [
        "classifierQuestions", "hmisClassifierQuestions", "equifaxConsent"
    ]},
    {name: "Your Signature", pages: [
        "signature"
    ]},
    {name: "Submit", pages: [
        "preSubmit"
    ]},
];

export interface ModuleState {
    application: Partial<RegisterRequest>,

    formNavState: FormNavState<Page>,
    miscState: any,
}

export const moduleState = ref<ModuleState|null>(null);

export const initNewApplication = (initialMiscState: any, invite: CitizenInvite):ModuleState => {
    const classifierQuestionAnswers:any = {};
    for (const q of invite.classifierQuestions) {
        classifierQuestionAnswers[q.id] = [];
    }

    return {
        application: {
            inviteCode: invite.id,
            username: "",
            password: "",
            profile: {
                firstName: "",
                lastName: "",
                dateOfBirth: new Date().getTime(),
            },
            classifierQuestionAnswers: classifierQuestionAnswers,
            demographics: [],
            needs: [],
            idempotencyToken: generateRandomId()
        },
        
        formNavState: {
            activePage: "welcome",
            previousPages: [],
            errors: [],
        },

        miscState: initialMiscState
    };
};

export const submitModule = async () => {  
    // Collate all the required info for the application, and submit it to the server
    return register(moduleState.value!.application as RegisterRequest);
};

export enum EquifaxConsentOptions {
    "Yes, my data can be shared" = "YES",
    "No, do not share my data" = "NO"
}

export enum HousingReadinessLocations {
    "Pryor Street" = "PRYOR_STREET",
}

export enum HousingReadinessType {
    "Rapid Rehousing" = "RAPID_REHOUSING",
    "Permanent Supportive Housing" = "PERMANENT_SUPPORTIVE_HOUSING"
}